import $ from 'jquery';

import './_schedule-widget.sass';

import tinycolor from 'tinycolor2';

import Class from './legacy-class';
import '../../../mui/popup';
import {pad0, parseFloatWithComma, prettyFloat} from '../../../utils/number';
import {escape_html} from '../../../utils/string';
import {formatTemp} from '../../../utils';

const _calc_temp2color = function (temp) {
    const min_temp = 10;
    const min_color = '#15b1d9';

    const high_temp = 27;
    const high_color = '#d93d15';

    const max_temp = 29;
    const max_color = '#e00000';

    if (temp > max_temp) return max_color;
    if (temp > high_temp) return high_color;
    if (temp < min_temp) return min_color;

    let v = (temp - min_temp) / (max_temp - min_temp);
    v = (v - 0.5) * 2;
    v = v >= 0 ? 1 - Math.pow(1 - v, 3) : -1 + Math.abs(Math.pow(-1 - v, 3));

    v = (v + 1) / 2;

    const hsl = tinycolor(min_color).toHsl();
    hsl.h = hsl.h + v * -180;
    return tinycolor(hsl).toHexString();
};

const _temp2color_cache = {};
const _temp2color = function (temp) {
    let result = _temp2color_cache[temp];
    if (result == null) {
        result = _calc_temp2color(temp);
        _temp2color_cache[temp] = result;
    }
    return result;
};

const _format_temp = function (temp) {
    if (temp < 0) {
        return `–${formatTemp(Math.abs(temp))}`;
    }
    return formatTemp(temp);
};

export const Palette = Class({
    init(
        temps,
        [valid_min, valid_max],
        temp2color = _temp2color,
        format_temp = _format_temp,
        show_custom_temp = true
    ) {
        let temp;
        const items_html = temps.map(
            (temp) =>
                `<div class='ui-therm-schedule-palette-button' temp2='${temp}'>
                <div class='ui-therm-schedule-palette-button-color' style='background-color: ${temp2color(
                    temp
                )}'></div>
                <div class='ui-therm-schedule-palette-button-label'>${format_temp(
                    temp
                )}</div>
            </div>`
        );

        this._element = $(`\
            <div class='ui-therm-schedule-palette'>
                ${items_html.join('')}
                ${
                    show_custom_temp
                        ? `
                    <div class='ui-therm-schedule-palette-button ui-therm-schedule-palette-button-other' temp2='other'>
                        <div class='ui-therm-schedule-palette-button-color' style='background-color: #777'></div>
                        <div class='ui-therm-schedule-palette-button-label'>другая температура</div>
                    </div>
                `
                        : ''
                }
            </div>\
        `)
            .popup({direction: 'bottom'})
            .on('click', '.ui-therm-schedule-palette-button', (event) => {
                const button = $(event.currentTarget);
                button.addClass('selected').siblings().removeClass('selected');
                temp = button.attr('temp2');

                let value;
                if (temp === 'other') {
                    value = null;
                    while (true) {
                        value = prompt(
                            'Введите значение температуры, °С',
                            value != null ? value : ''
                        );
                        if ([null, ''].includes(value)) {
                            this.hide();
                            return;
                        }

                        value = parseFloatWithComma(value);
                        if (value == null || isNaN(value))
                            alert('Некорректное значение');
                        else if (value < valid_min || value > valid_max)
                            alert(
                                `Допустимый диапазон температур: ${valid_min}...${valid_max} °C`
                            );
                        else break;
                    }
                } else value = parseFloat(temp);

                this.notify('selected', [value]);
                this.hide();
                return false;
            });

        this._shown = false;
    },

    element() {
        return this._element;
    },

    shown() {
        return this._shown;
    },
    show(position) {
        this._shown = true;
        return this._element.popup('show', {position});
    },
    hide() {
        this._shown = false;
        return this._element.popup('hide');
    },
}).implement(Class.EventSource);

export class ScheduleGrid {
    cell_width = 18;
    cell_height = 18;

    hours_height = 27;
    days_width = 25;
    days_gap = 4;

    _area_x = 25.5;
    _area_y = 27.5;

    font_family =
        'SegoeUI, Segoe UI, Trebuchet MS, Helvetica, Tahoma, Arial, Verdana, sans-serif';

    _current_temp = 22;

    constructor(_row_titles, temp2color = _temp2color, format_temp = _format_temp) {
        this._row_titles = _row_titles;
        this._temp2color = temp2color;
        this._format_temp = format_temp;

        this._col_count = 24;
        this._row_count = this._row_titles.length;

        this._width = this.days_width + this._col_count * this.cell_width + 1;
        this._height = this.hours_height + this._row_count * this.cell_height + 1;

        const scale = window.devicePixelRatio != null ? window.devicePixelRatio : 1;

        this._canvas = $('<canvas class="ui-schedule-widget-v2-grid"></canvas>');
        this._canvas[0].width = this._width * scale;
        this._canvas[0].height = this._height * scale;
        this._canvas[0].style.width = `${this._width}px`;
        this._canvas[0].style.height = `${this._height}px`;

        this._canvas.on('mousedown touchstart', (ev) => this._on_mouse_down(ev));
        this._ctx = this._canvas[0].getContext('2d');
        this._ctx.scale(scale, scale);

        this._field = new Array(this._row_count)
            .fill(0)
            .map((_, y) => new Array(this._col_count).fill(15 + y));

        this._ext_modes = {};
        this._labels = [];
        this._recalc_labels();

        this._selection = null;

        this.redraw();
    }

    element() {
        return this._canvas;
    }

    _cell_x(x_no) {
        return this._area_x + x_no * this.cell_width;
    }
    _cell_y(y_no) {
        return this._area_y + y_no * this.cell_height;
    }

    _cell_no(px, py) {
        return [
            Math.max(
                Math.min(
                    ~~((px - this._area_x) / this.cell_width),
                    this._col_count - 1
                ),
                0
            ),
            Math.max(
                Math.min(
                    ~~((py - this._area_y) / this.cell_height),
                    this._row_count - 1
                ),
                0
            ),
        ];
    }

    redraw() {
        this._ctx.clearRect(0, 0, this._width, this._height);
        this._draw_transaction(() => this._draw_axes());
        this._draw_transaction(() => this._draw_cells());
        this._draw_transaction(() => this._draw_grid());
        this._draw_transaction(() => this._draw_block_borders());
        this._draw_transaction(() => this._draw_border());
        this._draw_transaction(() => this._draw_labels());
        this._draw_transaction(() => this._draw_selection());
    }

    _draw_transaction(draw_func) {
        this._ctx.save();
        draw_func();
        this._ctx.restore();
    }

    _draw_axes() {
        const dash_len = 4;
        const hours_y_offset = 7;

        const axesColor =
            window._ui.getUITheme().palette.mode == 'dark' ? '#eee' : '444';

        this._ctx.beginPath();
        this._ctx.strokeStyle = '#888';
        for (let hour = 1; hour < this._col_count; hour += 2) {
            const x = this._cell_x(hour);
            this._ctx.moveTo(x, this.hours_height);
            this._ctx.lineTo(x, this.hours_height - dash_len);
        }
        this._ctx.stroke();

        this._ctx.fillStyle = axesColor;
        this._ctx.font = `400 14px ${this.font_family}`;
        this._ctx.textAlign = 'center';

        this._ctx.beginPath();

        for (let hour = 1; hour < this._col_count; hour += 2) {
            const x = this._cell_x(hour);
            this._ctx.save();
            this._ctx.translate(x, this.hours_height - hours_y_offset);
            this._ctx.font = `400 14px ${this.font_family}`;
            this._ctx.fillText(`${pad0(hour, 2)}`, 0, 0);

            this._ctx.font = `400 9px ${this.font_family}`;
            this._ctx.fillText('00', 13, -5);

            this._ctx.restore();
        }

        this._ctx.fillStyle = axesColor;
        this._ctx.font = `400 14px ${this.font_family}`;
        this._ctx.textAlign = 'right';
        this._ctx.textBaseline = 'middle';

        for (let i = 0; i < this._row_titles.length; i++) {
            const title = this._row_titles[i];
            const y = this._cell_y(i) + this.cell_height / 2;
            this._ctx.fillText(title, this._area_x - this.days_gap, y);
        }

        this._ctx.stroke();
    }

    _draw_grid() {
        this._ctx.strokeStyle = 'rgba(0, 0, 0, 0.2)';
        this._ctx.setLineDash?.([2, 2]);
        this._ctx.lineWidth = 1;

        this._ctx.beginPath();

        for (let i = 1; i < this._col_count; i++) {
            const x = this._area_x + i * this.cell_width;
            this._ctx.moveTo(x, this._cell_y(0));
            this._ctx.lineTo(x, this._cell_y(this._row_count));
        }

        for (let i = 1; i < this._row_count; i++) {
            const y = this._area_y + i * this.cell_height;
            this._ctx.moveTo(this._cell_x(0), y);
            this._ctx.lineTo(this._cell_x(this._col_count), y);
        }

        this._ctx.stroke();
    }

    _draw_border() {
        this._ctx.strokeStyle = '#808080';
        this._ctx.lineWidth = 1;

        this._ctx.strokeRect(
            this._area_x,
            this._area_y,
            this._col_count * this.cell_width,
            this._row_count * this.cell_height
        );
    }

    _draw_cells() {
        for (let x = 0; x < this._col_count; x++) {
            for (let y = 0; y < this._row_count; y++) {
                this._ctx.fillStyle = this._cell_color(this._field[y][x]);
                this._ctx.strokeStyle = '#ff0000';
                this._ctx.beginPath();
                this._ctx.fillRect(
                    this._cell_x(x),
                    this._cell_y(y),
                    // +1 make cells overlap to hide white gaps caused by 0.5px shift
                    this.cell_width + 1,
                    this.cell_height + 1
                );
            }
        }
    }

    _draw_block_borders() {
        this._ctx.strokeStyle = '#808080';
        this._ctx.lineWidth = 1;

        this._ctx.beginPath();

        for (let x = 0; x < this._col_count; x++) {
            for (let y = 0; y < this._row_count; y++) {
                if (x > 0 && this._field[y][x] !== this._field[y][x - 1]) {
                    const x_c = this._cell_x(x);
                    this._ctx.moveTo(x_c, this._cell_y(y));
                    this._ctx.lineTo(x_c, this._cell_y(y + 1));
                }

                if (y > 0 && this._field[y][x] !== this._field[y - 1][x]) {
                    const y_c = this._cell_y(y);
                    this._ctx.moveTo(this._cell_x(x), y_c);
                    this._ctx.lineTo(this._cell_x(x + 1), y_c);
                }
            }
        }

        this._ctx.stroke();
    }

    _find_areas() {
        const processed = new Array(this._col_count)
            .fill(0)
            .map(() => new Array(this._row_count));

        const areas = [];

        while (true) {
            // var x, y;
            // var asc, end;
            const queue = [];

            // Find starting cell and push it to queue
            for (let x = 0; x < this._col_count; x++) {
                for (let y = 0; y < this._row_count; y++) {
                    if (!processed[x][y]) {
                        queue.push([x, y]);
                        processed[x][y] = true;
                        break;
                    }
                }
                if (queue.length > 0) break;
            }

            if (queue.length === 0) break;

            const area_cells = []; // list of (x,y) of current same-color area
            areas.push(area_cells);
            while (queue.length > 0) {
                const [x, y] = queue.shift();
                area_cells.push([x, y]);

                const cur = this._field[y][x];

                const check = (x, y) => {
                    if (!processed[x][y] && this._field[y][x] === cur) {
                        queue.push([x, y]);
                        processed[x][y] = true;
                    }
                };

                if (x > 0) {
                    check(x - 1, y);
                }
                if (y > 0) {
                    check(x, y - 1);
                }
                if (x < this._col_count - 1) {
                    check(x + 1, y);
                }
                if (y < this._row_count - 1) {
                    check(x, y + 1);
                }
            }
        }

        return areas;
    }

    _area([x, y, w, h]) {
        return w * h;
    }
    _largest_rect(rect_a, rect_b) {
        return this._area(rect_a) >= this._area(rect_b) ? rect_a : rect_b;
    }
    _max_rect_for_hist(row_no, hist) {
        // let height, new_rect, start;
        const stack = [];
        const top = () => stack[stack.length - 1];
        let max_rect = [0, 0, 0, 0];

        for (let x = 0; x < hist.length; x++) {
            const height = hist[x];
            let start = x;
            while (true) {
                if (stack.length === 0 || height > top().height)
                    stack.push({start, height});
                else if (stack.length > 0 && height < top().height) {
                    const new_rect = [
                        top().start,
                        row_no + 1 - top().height,
                        x - top().start,
                        top().height,
                    ];
                    max_rect = this._largest_rect(max_rect, new_rect);
                    ({start} = stack.pop());
                    continue;
                }
                break;
            }
        }

        for (const {start, height} of stack) {
            const new_rect = [start, row_no + 1 - height, hist.length - start, height];
            max_rect = this._largest_rect(max_rect, new_rect);
        }
        return max_rect;
    }
    _find_max_rect_v2(cells, row_count, col_count) {
        // implementation from http://stackoverflow.com/a/4671342/1415080
        const field = new Array(row_count).fill(0).map(() => new Array(col_count));
        for (const [x, y] of cells) field[y][x] = true;

        let total_max_rect = [0, 0, 0, 0];

        let hist;
        for (let i = 0; i < field.length; i++) {
            const row = field[i];
            hist =
                i === 0
                    ? new Array(col_count).fill(0).map((_, x) => (field[0][x] ? 1 : 0))
                    : new Array(col_count)
                          .fill(0)
                          .map((_, x) => (row[x] ? hist[x] + 1 : 0));

            total_max_rect = this._largest_rect(
                total_max_rect,
                this._max_rect_for_hist(i, hist)
            );
        }

        return [
            [total_max_rect[0], total_max_rect[1]],
            [
                total_max_rect[2] + total_max_rect[0] - 1,
                total_max_rect[3] + total_max_rect[1] - 1,
            ],
        ];
    }

    _cell_label(value, cell_width) {
        if (typeof value === 'number') {
            switch (cell_width) {
                case 1:
                    return prettyFloat(value, 1);
                case 2:
                    if (value % 1 === 0) return this._format_temp(value);
                    else return prettyFloat(value, 1);
                default:
                    return this._format_temp(value);
            }
        }

        return this._ext_modes[value]?.name || '??';
    }

    _cell_color(value) {
        if (typeof value === 'number') return this._temp2color(value);

        if (this._ext_modes[value]?.color != null) return this._ext_modes[value]?.color;
        else {
            if (this._ext_modes[value]?.temp != null)
                return this._temp2color(this._ext_modes[value].temp);
            else return '#cccccc';
        }
    }

    _recalc_labels() {
        this._labels = this._find_areas().map((area) => {
            const [x0, y0] = area[0];
            const temp = this._field[y0][x0];
            const [[x1, y1], [x2, y2]] = this._find_max_rect_v2(
                area,
                this._row_count,
                this._col_count
            );

            const cell_width = x2 - x1 + 1;
            const pixel_width = cell_width * this.cell_width;
            const label = this._cell_label(temp, cell_width);

            return [
                label,
                (this._cell_x(x1) + this._cell_x(x2 + 1)) / 2,
                (this._cell_y(y1) + this._cell_y(y2 + 1)) / 2,
                pixel_width,
            ];
        });
    }

    _draw_labels() {
        this._ctx.font = `15px ${this.font_family}`;
        this._ctx.strokeStyle = '#222';
        this._ctx.textAlign = 'center';
        this._ctx.textBaseline = 'middle';

        for (const [label, x, y, max_width] of this._labels) {
            const {width} = this._ctx.measureText(label);
            if (width <= max_width) this._ctx.fillText(label, x, y);
            else {
                this._ctx.save();
                this._ctx.textAlign = 'left';
                this._ctx.rect(x - max_width / 2, 0, max_width, this._canvas[0].height);
                this._ctx.clip();
                this._ctx.fillText(label, x - max_width / 2, y);
                this._ctx.restore();
            }
        }
    }

    _draw_selection() {
        if (this._selection == null) return;

        this._ctx.fillStyle = 'rgba(59, 68, 196, 0.3)';
        this._ctx.strokeStyle = 'rgba(59, 68, 196, 0.5)';

        const [[x1, y1], [x2, y2]] = this._selection;
        const rect = [
            this._cell_x(x1),
            this._cell_y(y1),
            this._cell_x(x2 + 1) - this._cell_x(x1),
            this._cell_y(y2 + 1) - this._cell_y(y1),
        ];

        this._ctx.fillRect(...rect);
        this._ctx.strokeRect(...rect);
    }

    _event_px(event) {
        // event = __guard__(event.originalEvent != null ? event.originalEvent.changedTouches : undefined, x => x[0]) != null ? __guard__(event.originalEvent != null ? event.originalEvent.changedTouches : undefined, x => x[0]) : event;
        event = event.originalEvent?.changedTouches?.[0] || event;

        const bounds = this._canvas[0].getBoundingClientRect();
        return [
            ((event.clientX - bounds.left) * this._canvas.outerWidth()) / bounds.width,
            ((event.clientY - bounds.top) * this._canvas.outerHeight()) / bounds.height,
        ];
    }

    _on_mouse_down(event) {
        let [px, py] = this._event_px(event);
        const [start_x, start_y] = this._cell_no(px, py);

        this._selection = [
            [start_x, start_y],
            [start_x, start_y],
        ];

        this.redraw();

        const on_drag = (event) => {
            [px, py] = this._event_px(event);
            const [cx, cy] = this._cell_no(px, py);

            this._selection = [
                [Math.min(start_x, cx), Math.min(start_y, cy)],
                [Math.max(start_x, cx), Math.max(start_y, cy)],
            ];

            this.redraw();
        };

        $(document)
            .on('mousemove touchmove', on_drag)
            .one('mouseup touchend', () => {
                $(document).off('mousemove touchmove', on_drag);

                if (this._selection != null)
                    this._fill_cells(this._current_temp, this._selection);
                this._selection = null;

                this.redraw();
            });

        return false;
    }

    _fill_cells(temp, rect) {
        // console.log('_fill_cels', temp, rect);
        const [[x1, y1], [x2, y2]] = rect;

        for (let x = x1; x <= x2; x++)
            for (let y = y1; y <= y2; y++) this._field[y][x] = temp;
        // console.log('this._field', this._field);

        this.notify('changed', [this._field]);

        this._recalc_labels();
        this.redraw();
    }

    set_current_temp(temp) {
        return (this._current_temp = temp);
    }

    get_field() {
        return this._field;
    }
    set_field(field) {
        this._field = new Array(this._row_count)
            .fill(0)
            .map(() => new Array(this._col_count));
        for (let x = 0; x < this._col_count; x++)
            for (let y = 0; y < this._row_count; y++) {
                const cur = field?.[y]?.[x];
                this._field[y][x] = cur != null ? cur : 0;
            }
        this._recalc_labels();
        this.redraw();
    }

    set_ext_modes(value2props) {
        this._ext_modes = value2props;
        this._recalc_labels();
        this.redraw();
    }
}

Class.class_methods.implement.call(ScheduleGrid, Class.EventSource);

export const ScheduleWidget = Class({
    predefined_temps: __range__(5, 40, true),
    valid_temp_range: [3, 99],

    init(row_titles) {
        this._element = $(`
            <div class='ui-schedule-widget-v2'>
                <div>
                    Выбранная температура:
                    <div class='ui-therm-schedule-show-palette'>
                        <div class='ui-therm-schedule-palette-button-color' style='background-color: ${_temp2color(
                            22
                        )}'></div>
                        <div class='ui-therm-schedule-palette-button-label'>${_format_temp(
                            22
                        )}</div>
                    </div>
                </div>
            </div>
        `);

        this._grid = new ScheduleGrid(row_titles);
        this._grid.bind('changed', this.notifier('changed'));
        this._grid.element().appendTo(this._element);
        this._grid.set_current_temp(22);

        this._palette_button = this._element.find('.ui-therm-schedule-show-palette');

        this._palette_button
            .on('mousedown', false)
            .on('click', () => {
                if (this._palette.shown()) this._palette.hide();
                else {
                    this._palette.show({
                        my: 'center top',
                        at: 'center bottom',
                        of: this._palette_button,
                    });

                    $(document).one('mousedown', () => this._palette.hide());
                }
                return false;
            })
            .end();

        this._palette = new Palette(this.predefined_temps, this.valid_temp_range);
        this._palette.element().appendTo('.theme-general-div:first');
        this._palette.bind('selected', (temp) => {
            this._grid.set_current_temp(temp);
            this._palette_button
                .find('.ui-therm-schedule-palette-button-color')
                .css('background-color', _temp2color(temp));
            this._palette_button
                .find('.ui-therm-schedule-palette-button-label')
                .text(_format_temp(temp));
        });
    },

    element() {
        return this._element;
    },

    destroy() {
        return this._palette.element().remove();
    },
})
    .implement(Class.EventSource)
    .implement(
        Class.Properties({
            schedule: {
                get() {
                    return this._grid.get_field();
                },
                set(field) {
                    this._grid.set_field(field);
                },
            },
        })
    );

export const ScheduleWidgetWithModes = Class({
    predefined_temps: __range__(5, 40, true),
    valid_temp_range: [3, 99],

    _random_id() {
        return 'ui-schedule-widget-random-id-' + Math.random().toString().substr(2);
    },

    init(row_titles) {
        this._radio_temp_id = this._random_id();
        this._radio_mode_id = this._random_id();

        this._element = $(`
            <div class='ui-schedule-widget-v2'> 
                <form class='ui-schedule-widget-controls'> 
                    <span class='ui-therm-schedule-palette-selector'> 
                        <span class='ui-schedule-widget-control-title'> 
                            <input type='radio' name='ui-schedule-widget-temp-source' class='ui-schedule-widget-temp' id='${
                                this._radio_temp_id
                            }' checked/> 
                            <span class='mui_radiobutton'></span> 
                            <label for='${this._radio_temp_id}'>Температура:</label> 
                        </span> 
                        <div class='ui-therm-schedule-show-palette' role='temperature'> 
                            <div class='ui-therm-schedule-palette-button-color' style='background-color: ${_temp2color(
                                22
                            )}'></div> 
                            <div class='ui-therm-schedule-palette-button-label'>${_format_temp(
                                22
                            )}</div> 
                        </div> 
                    </span> 
                    
                    <span class='ui-schedule-widget-control-title'> 
                        <input type='radio' name='ui-schedule-widget-temp-source' class='ui-schedule-widget-mode' id='${
                            this._radio_mode_id
                        }'/> 
                        <span class='mui_radiobutton'></span> 
                        <label for='${this._radio_mode_id}'>Режим:</label> 
                    </span> 
                    <select class='ui-schedule-widget-control-select'></select> 
                </form> 
            </div>
        `);

        this._grid = new ScheduleGrid(row_titles);
        this._grid.bind('changed', this.notifier('changed'));
        this._grid.element().appendTo(this._element);
        this._grid.set_current_temp(22);
        this._prev_temp = 22;

        this._radio_temp = this._element
            .find('.ui-schedule-widget-temp')
            .on('click', () => this._apply_palette_temp(undefined));
        this._radio_mode = this._element
            .find('.ui-schedule-widget-mode')
            .on('click', () => this._apply_mode());

        this._modes_select = this._element.find('.ui-schedule-widget-control-select');

        this._temp_button = this._element.find('[role="temperature"]');
        this._modes_button = this._element.find('[role="modes"]');

        this._temp_button
            .on('mousedown', false)
            .on('click', () => {
                if (this._palette.shown()) this._palette.hide();
                else {
                    this._palette.show({
                        my: 'center top',
                        at: 'center bottom',
                        of: this._temp_button,
                    });

                    $(document).one('mousedown', () => this._palette.hide());
                }
                return false;
            })
            .end();

        this._palette = new Palette(this.predefined_temps, this.valid_temp_range);
        this._palette.element().appendTo('.theme-general-div:first');
        this._palette.bind('selected', (temp) => this._apply_palette_temp(temp));

        this._modes_select.on('change', () => this._apply_mode());
    },

    element() {
        return this._element;
    },

    _apply_palette_temp(temp) {
        if (temp === undefined) temp = this._prev_temp;
        this._radio_temp.prop('checked', true);
        this._grid.set_current_temp(temp);
        this._temp_button
            .find('.ui-therm-schedule-palette-button-color')
            .css('background-color', _temp2color(temp));
        this._temp_button
            .find('.ui-therm-schedule-palette-button-label')
            .text(_format_temp(temp));
        this._prev_temp = temp;
    },

    _apply_mode() {
        this._radio_mode.prop('checked', true);
        this._grid.set_current_temp(this._modes_select.val());
    },

    destroy() {
        return this._palette.element().remove();
    },
})
    .implement(Class.EventSource)
    .implement(
        Class.Properties({
            schedule: {
                get() {
                    return this._grid.get_field();
                },
                set(field) {
                    this._grid.set_field(field);
                },
            },

            modes: {
                set(modes) {
                    const cur = this._modes_select.val();

                    this._modes_select.html(
                        Object.entries(modes).map(
                            ([mode_id, mode_props]) =>
                                `<option value='${escape_html(mode_id)}'>${escape_html(
                                    mode_props.name || ''
                                )}</option>`
                        )
                    );

                    this._modes_select.val(cur);
                    if (!this._modes_select.val())
                        this._modes_select.val(
                            this._element
                                .find('.ui-schedule-widget-control-select option:first')
                                .val()
                        );

                    this._grid.set_ext_modes(modes);

                    if (this._radio_temp.prop('checked')) this._apply_palette_temp();
                    if (this._radio_mode.prop('checked')) this._apply_mode();
                },
            },

            show_temperature_selector: {
                value: true,
                set(value) {
                    this._element
                        .find('.ui-therm-schedule-palette-selector')
                        .toggle(value);
                    if (!this._modes_select.val())
                        this._modes_select.val(
                            this._element
                                .find('.ui-schedule-widget-control-select option:first')
                                .val()
                        );
                    if (!value) this._element.find('.ui-schedule-widget-mode').click();
                    this._element
                        .find('.ui-schedule-widget-mode')
                        .parent()
                        .toggle(value);
                },
            },
        })
    );

function __range__(left, right, inclusive) {
    const range = [];
    const ascending = left < right;
    const end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)
        range.push(i);
    return range;
}
